:host {
  display: flex;
  flex-direction: column;
  max-width: 100%;
  padding: 0 0 0 calc(var(--spacer) * 2);
}

gz-labeled-content::part(label) {
  width: 35%;
  display: flex;
  align-items: center;
}

gz-labeled-content::part(content) {
  width: 65%;
}

.copy-labeled-content {
  margin-top: -4px;
}

.copy-icon {
  width: 36px;
}

.footer {
  margin-top: auto;
  padding: 12px 0;
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-wrapper {
  display: flex;
  align-items: center;
  padding-right: 16px;
  gap: 10px;
  position: relative;
}

.header-wrapper:not(:last-child) {
  margin-bottom: calc(var(--spacer) * 3);
}

.header-type {
  color: var(--body-text-arrows-400);
}

.node-wrapper {
  width: 48px;
  height: 48px;
  border-width: 4px;
  border-style: solid;
  border-radius: 50%;
  background: var(--chart-302-icon-buttons-titles);
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-section-wrapper {
  position: relative;
  margin-bottom: calc(var(--spacer) * 2);
}

.header-section-wrapper::before {
  content: '';
  position: absolute;
  width: 1px;
  height: 24px;
  top: 48px;
  left: 23.5px;
  background: var(--gz-loader-background);
}

.border-bottom {
  border-bottom: 1px solid var(--grey-layout-chart-100);
}
